import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useBuyerAuth } from '../../contexts/BuyerAuthContext';

const BuyerAccess = ({ language }) => {
  const { isAuthenticated, signOut } = useBuyerAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBuyerClick = () => {
    if (isAuthenticated) {
      navigate('/buyer-dashboard');
    } else {
      navigate('/buyer-login');
    }
  };

  const handleLogout = async () => {
    await signOut();
    navigate('/home');
  };

  return (
    <div className="relative group">
      <button
        onClick={handleBuyerClick}
        className="flex items-center gap-2 px-3 py-2 rounded-md border border-border hover:bg-muted transition-smooth text-sm font-medium"
        aria-label="Buyer access"
      >
        <Icon name="User" size={18} />
        <span className="hidden sm:inline">{language === 'en' ? 'Buyer' : '买家'}</span>
      </button>

      {isAuthenticated && (
        <div className="absolute top-full right-0 mt-1 bg-popover border border-border rounded-md shadow-modal opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-smooth min-w-[140px]">
          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-smooth flex items-center gap-2"
          >
            <Icon name="LogOut" size={16} />
            {language === 'en' ? 'Logout' : '登出'}
          </button>
        </div>
      )}
    </div>
  );
};

export default BuyerAccess;